// src/data/blogArticles.js
// Articles écrits en dur pour démarrer. Pas besoin de CMS pour l'instant.
// Pour ajouter un article : dupliquez un objet et changez le contenu.

const blogArticles = [
  {
    slug: "phishing-pme-comment-se-proteger",
    title: "Phishing en entreprise : pourquoi les PME sont les plus exposées",
    excerpt:
      "Les grandes entreprises ont des équipes SOC dédiées. Les PME, elles, ont souvent zéro barrière contre le phishing. Voici pourquoi c'est le premier vecteur d'attaque et comment s'en prémunir sans budget énorme.",
    date: "2026-06-02",
    readingTime: "6 min",
    author: "Équipe Cyber-Guard",
    category: "Sensibilisation",
    content: `
Le phishing reste, année après année, le point d'entrée numéro un des cyberattaques. Pour les grandes structures, la riposte est organisée : SOC, filtrage avancé, simulations trimestrielles. Pour une PME de 20 à 100 salariés, la réalité est souvent tout autre.

## Pourquoi les PME sont des cibles privilégiées

Les attaquants savent que les petites structures manquent de temps et de budget pour la sensibilisation. Un seul clic sur un lien piégé suffit parfois à compromettre l'ensemble du système d'information.

Trois facteurs aggravants reviennent systématiquement :

- Absence de formation régulière des équipes
- Pas de procédure claire en cas de doute sur un email
- Confiance excessive envers les expéditeurs internes ou habituels

## Ce qui fonctionne réellement

La sensibilisation ponctuelle ne suffit pas. Ce qui change la donne, c'est la répétition : des simulations de phishing régulières, avec un retour pédagogique immédiat pour la personne qui a cliqué, plutôt qu'une sanction.

Combinée à une politique simple ("on ne clique jamais sur un lien sans vérifier l'expéditeur"), cette approche réduit drastiquement le taux de clic sur plusieurs mois.

## Par où commencer

Pas besoin d'un budget de grande entreprise pour démarrer. Une première campagne de test, suivie d'un debrief avec les équipes, donne déjà une photographie claire du niveau de vigilance interne.
    `,
  },
  {
    slug: "rgpd-checklist-securite-technique",
    title: "RGPD et sécurité technique : la checklist que les DPO oublient souvent",
    excerpt:
      "Le RGPD est souvent traité comme un sujet juridique. Mais sans mesures techniques réelles derrière, la conformité reste sur le papier. Voici les points de contrôle technique qui font vraiment la différence.",
    date: "2026-06-16",
    readingTime: "7 min",
    author: "Équipe Cyber-Guard",
    category: "Conformité",
    content: `
Beaucoup d'entreprises pensent être en conformité RGPD parce qu'elles ont rédigé un registre de traitement et une politique de confidentialité. C'est une base nécessaire, mais insuffisante : l'article 32 du règlement impose des mesures techniques et organisationnelles adaptées au risque.

## Les angles morts les plus fréquents

Sur le terrain, certains manques reviennent constamment, même dans des entreprises qui se pensent conformes :

- Chiffrement des données au repos incomplet ou absent sur certains environnements
- Droits d'accès trop larges, jamais revus depuis la création des comptes
- Journaux d'accès non conservés ou non exploitables en cas d'incident
- Absence de procédure documentée de notification de violation sous 72h

## Faire le lien entre juridique et technique

La conformité RGPD ne peut pas rester un sujet uniquement porté par le DPO. Elle demande un dialogue régulier avec les équipes techniques, qui seules savent ce qui est réellement en place sur l'infrastructure.

## Une approche pragmatique

Plutôt que de viser l'exhaustivité immédiate, mieux vaut prioriser les traitements les plus sensibles (données de santé, données financières, données de mineurs) et sécuriser ceux-là en premier, avec un plan de mise en conformité progressif pour le reste.
    `,
  },
  {
    slug: "pentest-vs-scan-vulnerabilites",
    title: "Pentest ou scan de vulnérabilités : lequel choisir (et quand) ?",
    excerpt:
      "Ces deux termes sont souvent confondus, alors qu'ils répondent à des besoins différents. Voici comment savoir lequel est adapté à votre situation, et pourquoi les deux sont complémentaires plutôt que concurrents.",
    date: "2026-07-01",
    readingTime: "5 min",
    author: "Équipe Cyber-Guard",
    category: "Technique",
    content: `
Sur le papier, scan de vulnérabilités et test d'intrusion (pentest) visent le même objectif : identifier des failles avant qu'un attaquant ne le fasse. Dans la pratique, ce sont deux exercices très différents.

## Le scan de vulnérabilités

Automatisé, rapide, peu coûteux. Un scanner parcourt votre infrastructure et compare ce qu'il trouve à une base de vulnérabilités connues. C'est un excellent outil de suivi régulier, mais il ne comprend pas le contexte métier et génère parfois des faux positifs.

## Le pentest

Réalisé par un humain, souvent sur plusieurs jours. Le testeur ne se contente pas de lister des failles : il essaie de les exploiter, de les enchaîner, de simuler un scénario d'attaque réaliste. C'est plus coûteux, mais bien plus révélateur de l'impact réel d'une faille.

## Lequel choisir ?

En pratique, ce n'est pas un choix binaire :

- Le scan de vulnérabilités a sa place en continu, idéalement automatisé à chaque déploiement
- Le pentest intervient ponctuellement, une à deux fois par an, ou avant une mise en production critique

Utilisés ensemble, ils couvrent deux besoins complémentaires : la détection continue d'un côté, la validation approfondie de l'autre.
    `,
  },
  {
    slug: "configurer-dmarc-guide-pme",
    title: "Comment configurer DMARC : le guide pas à pas pour les PME",
    excerpt:
      "DMARC empêche qu'on se fasse passer pour vous par email. Gmail, Yahoo et Outlook l'exigent des gros expéditeurs. Le guide en 5 étapes, sans bloquer vos emails.",
    date: "2026-10-14",
    readingTime: "9 min",
    author: "Équipe Cyber-Guard",
    category: "Sécurité email",
    content: `
N'importe qui peut envoyer un email en affichant votre adresse comme expéditeur. C'est la base des arnaques au faux fournisseur et au faux changement de RIB : le message semble venir de chez vous, et vos clients n'ont aucune raison de se méfier.

DMARC est le réglage qui permet aux messageries de repérer et de bloquer ces faux emails. Il s'appuie sur deux autres protections, SPF et DKIM, et se configure entièrement dans la zone DNS de votre domaine. Comptez environ une heure de configuration, puis quelques semaines d'observation avant de passer en mode bloquant.

## Pourquoi c'est devenu incontournable

Depuis février 2024, Gmail et Yahoo exigent SPF, DKIM et un enregistrement DMARC (au minimum en mode p=none) des domaines qui leur envoient plus de 5 000 emails par jour. Microsoft applique les mêmes règles depuis le 5 mai 2025 pour Outlook.com, Hotmail et Live : les messages non conformes partent d'abord en spam, puis sont rejetés.

Même si vous envoyez beaucoup moins d'emails, ces trois réglages améliorent votre délivrabilité et rendent l'usurpation de votre domaine bien plus difficile.

## Avant de commencer

- Un accès à la zone DNS de votre domaine, chez votre registrar ou votre hébergeur (OVH, Hostinger, Gandi, Cloudflare...).
- La liste de tous les services qui envoient des emails avec votre domaine : messagerie, outil de newsletter, CRM, logiciel de facturation, formulaires du site.
- Une adresse pour recevoir les rapports DMARC, par exemple dmarc@votre-domaine.fr.

Le deuxième point est le plus souvent négligé. Un service oublié, c'est un service dont les emails seront bloqués le jour où vous durcirez DMARC.

## Étape 1 : vérifier ou créer l'enregistrement SPF

SPF liste les serveurs autorisés à envoyer des emails pour votre domaine. C'est un enregistrement TXT placé à la racine du domaine (tous les détails dans notre article [SPF : comprendre et configurer l'enregistrement](/blog/comprendre-spf-email)). Exemple pour une entreprise sur Google Workspace qui utilise aussi un outil de newsletter :

\`\`\`
Type   : TXT
Nom    : @ (la racine de votre-domaine.fr)
Valeur : v=spf1 include:_spf.google.com include:spf.votre-outil-newsletter.com ~all
\`\`\`

Chaque service indique dans sa documentation la mention \`include:\` à ajouter. Trois règles à respecter :

- Un seul enregistrement SPF par domaine. S'il y en a deux, SPF est considéré comme invalide.
- Dix consultations DNS au maximum : chaque \`include:\` en compte au moins une. Retirez les services que vous n'utilisez plus.
- Terminez par \`~all\` pendant la mise en place, puis par \`-all\` quand vous êtes sûr que tous vos services sont listés.

## Étape 2 : activer DKIM

DKIM ajoute une signature numérique à chaque email. C'est votre service d'envoi qui génère la clé ; vous n'avez qu'à publier la partie publique dans votre DNS. Les intitulés des menus peuvent varier légèrement selon la langue de votre console.

- Google Workspace : console d'administration, puis Applications, Google Workspace, Gmail, Authentifier les e-mails. Générez la clé, publiez l'enregistrement TXT \`google._domainkey\` indiqué, puis cliquez sur Démarrer l'authentification.
- Microsoft 365 : portail Microsoft Defender, page des paramètres d'authentification des e-mails, onglet DKIM. Publiez les deux enregistrements CNAME \`selector1\` et \`selector2\` indiqués, puis activez la signature pour votre domaine.
- Outil de newsletter, CRM, facturation : cherchez « authentification du domaine » ou « DKIM » dans leurs paramètres. La plupart fournissent un ou deux enregistrements à copier.

## Étape 3 : publier DMARC en mode surveillance

DMARC se publie sur un sous-domaine dédié, \`_dmarc\` :

\`\`\`
Type   : TXT
Nom    : _dmarc
Valeur : v=DMARC1; p=none; rua=mailto:dmarc@votre-domaine.fr
\`\`\`

- \`v=DMARC1\` : la version, toujours en premier.
- \`p=none\` : la politique. En mode none, rien n'est bloqué : les messageries vous envoient seulement des rapports.
- \`rua=mailto:...\` : l'adresse qui reçoit les rapports quotidiens.

Si l'adresse de rapport est sur un autre domaine que le vôtre, ce domaine doit accepter de recevoir vos rapports. Les services d'analyse DMARC gèrent ce point pour vous.

## Étape 4 : lire les rapports pendant deux à quatre semaines

Gmail, Outlook, Yahoo et les autres grandes messageries vous envoient chaque jour un rapport au format XML : qui a envoyé des emails avec votre domaine, depuis quels serveurs, et si SPF et DKIM sont passés. Ces fichiers sont difficiles à lire tels quels ; un service d'analyse de rapports DMARC, souvent gratuit pour les petits volumes, les transforme en tableau.

Ce que vous cherchez :

- Chacun de vos services légitimes doit apparaître avec SPF ou DKIM « aligné », c'est-à-dire validé pour votre propre domaine, et pas seulement pour celui du prestataire.
- Un service légitime en échec : il manque dans SPF, ou son DKIM n'est pas activé. Corrigez avant d'aller plus loin.
- Des sources inconnues en échec : ce sont souvent des tentatives d'usurpation. C'est exactement ce que DMARC va bloquer.

## Étape 5 : durcir la politique, palier par palier

Quand tous vos services légitimes passent, montez la politique :

1. \`p=quarantine\` : les emails en échec partent en spam. Vous pouvez d'abord ne l'appliquer qu'à une partie du trafic avec \`pct=25\`, puis augmenter.
2. Observez les rapports une à deux semaines de plus.
3. \`p=reject\` : les emails en échec sont refusés. Votre domaine est alors réellement protégé.

Pensez aussi aux sous-domaines : par défaut, ils suivent la politique principale, et la mention \`sp=\` permet de leur en donner une différente.

## Les erreurs les plus fréquentes

- Deux enregistrements SPF sur le même domaine : SPF devient invalide.
- Un service d'envoi oublié, découvert le jour où ses emails sont bloqués : d'où l'importance de l'étape 4.
- Rester en \`p=none\` pour toujours : vous observez, mais vous ne protégez rien.
- Une adresse de rapport qui n'existe pas ou qui déborde : les rapports peuvent être nombreux, prévoyez une boîte dédiée.
- Un domaine qui n'envoie aucun email laissé sans protection : publiez \`v=spf1 -all\` et une politique DMARC \`p=reject\` pour qu'il ne puisse servir d'expéditeur à personne.

## Vérifier votre configuration

Une fois les enregistrements publiés, vérifiez que tout est en place : [CyberGuard teste SPF, DKIM et DMARC en 2 minutes](/verifier-dmarc-spf-dkim) et vous indique le niveau de votre politique DMARC. Relancez le test à chaque palier pour confirmer que la nouvelle politique est bien publiée.
    `,
  },
  {
    slug: "comprendre-spf-email",
    title: "SPF : comprendre et configurer l'enregistrement qui protège vos emails",
    excerpt:
      "SPF dit au monde quels serveurs ont le droit d'envoyer vos emails. Syntaxe, limite des 10 consultations, erreurs fréquentes : l'essentiel pour une PME.",
    date: "2026-10-14",
    readingTime: "7 min",
    author: "Équipe Cyber-Guard",
    category: "Sécurité email",
    content: `
SPF (Sender Policy Framework) est la plus ancienne des trois protections email, avec DKIM et DMARC. Son principe est simple : vous publiez dans votre DNS la liste des serveurs autorisés à envoyer des emails pour votre domaine, et les messageries qui reçoivent un email vérifient qu'il vient bien de l'un d'eux.

Simple sur le papier, SPF est pourtant l'enregistrement qui casse le plus souvent. Un service oublié, une limite technique dépassée, et vos propres emails partent en spam.

## Ce que SPF vérifie, et ce qu'il ne vérifie pas

SPF contrôle l'adresse d'enveloppe de l'email, celle qui sert aux retours d'erreur (appelée Return-Path), et non l'adresse affichée dans le champ « De » que voit le destinataire. Un fraudeur peut donc passer SPF avec son propre domaine tout en affichant le vôtre.

C'est pour cela que SPF seul ne suffit pas : c'est DMARC qui exige que le domaine validé par SPF corresponde à celui affiché. Les deux vont ensemble, voir notre guide [Comment configurer DMARC](/blog/configurer-dmarc-guide-pme).

## Lire un enregistrement SPF

\`\`\`
v=spf1 include:_spf.google.com include:spf.votre-outil.com ip4:203.0.113.10 -all
\`\`\`

- \`v=spf1\` : la version, obligatoire et toujours en premier.
- \`include:\` : autorise les serveurs d'un service tiers (messagerie, newsletter, CRM). Le service vous donne la valeur exacte.
- \`ip4:\` et \`ip6:\` : autorisent une adresse ou une plage précise, par exemple votre propre serveur.
- \`a\` et \`mx\` : autorisent les serveurs désignés par les enregistrements A ou MX de votre domaine.
- \`-all\` ou \`~all\` : ce qu'il faut faire de tout le reste. \`-all\` signifie « refuser », \`~all\` « accepter mais marquer comme suspect ».

N'utilisez jamais \`+all\`, qui autorise le monde entier à envoyer en votre nom, ni le mécanisme \`ptr\`, déconseillé par la norme.

## Les trois règles qui évitent la plupart des pannes

### Un seul enregistrement SPF par domaine

Si deux enregistrements TXT commencent par \`v=spf1\`, SPF est considéré comme invalide. C'est l'erreur classique quand un nouveau prestataire demande « d'ajouter son SPF » : il faut fusionner sa mention \`include:\` dans l'enregistrement existant, pas en créer un second.

### Dix consultations DNS au maximum

Pour vérifier SPF, le serveur destinataire a le droit de faire au plus dix requêtes DNS. Chaque \`include:\`, \`a\`, \`mx\` et \`redirect=\` en consomme au moins une, et un \`include:\` peut lui-même en contenir d'autres. Au-delà de dix, SPF échoue en erreur permanente, comme s'il n'existait pas. Les mentions \`ip4:\`, \`ip6:\` et \`all\` ne comptent pas.

Pour rester sous la limite, retirez les services que vous n'utilisez plus. Méfiez-vous de « l'aplatissement » (remplacer les \`include:\` par les adresses IP qu'ils contiennent) : si le prestataire change ses serveurs, votre SPF devient faux sans que vous le sachiez.

### Bien choisir la fin : -all ou ~all

Avec \`-all\`, un email venu d'un serveur non listé peut être refusé directement. Avec \`~all\`, il est accepté mais marqué. Pendant la mise en place, \`~all\` évite de bloquer un service oublié. Une fois tous vos services listés et DMARC en place, \`-all\` est le réglage le plus strict, et c'est celui que recommande CyberGuard.

## Les cas particuliers à ne pas oublier

- Les sous-domaines n'héritent pas du SPF du domaine principal. Si factures.votre-domaine.fr envoie des emails, il lui faut son propre enregistrement.
- Un domaine qui n'envoie aucun email doit quand même être protégé : publiez \`v=spf1 -all\`, et une politique DMARC en \`p=reject\`.
- Les emails transférés automatiquement depuis une autre boîte échouent souvent à SPF, puisque c'est le serveur de transfert qui les renvoie. C'est normal : DKIM, qui survit au transfert, prend alors le relais pour DMARC.

## Vérifier votre SPF

Après chaque modification, attendez la propagation DNS, en général de quelques minutes à quelques heures, puis testez. [CyberGuard vérifie votre SPF, votre DKIM et votre DMARC en 2 minutes](/verifier-dmarc-spf-dkim) et vous signale un enregistrement absent, souple ou mal formé.
    `,
  },
  {
    slug: "usurpation-domaine-email-pme",
    title: "Usurpation de domaine par email : les trois formes d'arnaque et comment s'en protéger",
    excerpt:
      "Faux RIB, faux fournisseur, faux dirigeant : les fraudeurs se font passer pour vous par email. Les trois techniques qu'ils utilisent et la parade à chacune.",
    date: "2026-10-14",
    readingTime: "7 min",
    author: "Équipe Cyber-Guard",
    category: "Sensibilisation",
    content: `
Un client reçoit un email « de votre part » lui annonçant un changement de coordonnées bancaires. Il paie la facture suivante sur le nouveau RIB, qui appartient à un fraudeur. Ce scénario, appelé fraude au faux RIB ou au faux fournisseur, touche chaque année de nombreuses PME, et l'entreprise usurpée en paie souvent le prix en confiance perdue.

Les fraudeurs n'ont pas besoin de pirater votre messagerie pour y arriver. Ils disposent de trois techniques, et chacune demande une parade différente.

## 1. L'usurpation directe de votre domaine

Le fraudeur envoie un email avec votre adresse exacte dans le champ « De », par exemple comptabilite@votre-domaine.fr, depuis un serveur qui n'a rien à voir avec vous. Techniquement, rien ne l'en empêche : le protocole email ne vérifie pas l'expéditeur par défaut.

La parade est technique et entièrement entre vos mains : SPF, DKIM et surtout DMARC en mode \`p=reject\`. Une fois en place, les grandes messageries (Gmail, Outlook, Yahoo...) refusent les emails qui prétendent venir de votre domaine sans en avoir le droit. Notre guide [Comment configurer DMARC](/blog/configurer-dmarc-guide-pme) détaille la mise en place pas à pas.

C'est la seule des trois formes que vous pouvez bloquer complètement. Si votre DMARC est absent ou en \`p=none\`, c'est la porte la plus ouverte.

## 2. Le domaine sosie

Le fraudeur achète un nom de domaine qui ressemble au vôtre : une lettre changée (votre-domalne.fr), un tiret ajouté ou retiré, une autre extension (.com au lieu de .fr), ou un caractère d'un autre alphabet qui ressemble à une lettre latine. Ce domaine lui appartient vraiment : il peut configurer son propre SPF et son propre DMARC, et ses emails passent tous les contrôles.

DMARC ne protège que votre domaine exact. Contre les sosies, les parades sont :

- Réserver les variantes les plus évidentes de votre nom (autres extensions, fautes de frappe courantes). Un nom de domaine coûte quelques euros par an.
- Surveiller l'apparition de nouveaux domaines proches du vôtre. Les certificats SSL étant publics, des outils gratuits comme crt.sh permettent de chercher les certificats émis pour des noms ressemblants.
- Former vos équipes et vos clients à regarder l'adresse complète de l'expéditeur, pas seulement le nom affiché.

## 3. Le nom d'affichage trompeur

La technique la plus simple : l'email vient d'une adresse quelconque, par exemple une boîte Gmail, mais le nom affiché est « Direction - Votre Entreprise ». Sur téléphone, beaucoup de messageries n'affichent que ce nom. C'est le ressort habituel de la fraude au président, où un faux dirigeant demande un virement urgent et confidentiel.

Aucun réglage DNS ne peut l'empêcher, puisque votre domaine n'est pas utilisé. La parade est organisationnelle.

## La règle qui déjoue les trois

Quelle que soit la technique, l'arnaque finit toujours par une demande : changer un RIB, faire un virement, transmettre des identifiants. Une procédure simple suffit à la neutraliser :

1. Tout changement de coordonnées bancaires est confirmé par téléphone, au numéro déjà connu, jamais à celui indiqué dans l'email.
2. Tout virement inhabituel ou urgent demande une double validation par deux personnes.
3. Prévenez vos clients une fois pour toutes : « nous ne changerons jamais nos coordonnées bancaires par simple email ».

## Si c'est déjà arrivé

Contactez immédiatement votre banque : un virement frauduleux peut parfois être bloqué s'il est signalé très vite. Signalez ensuite l'escroquerie sur 17Cyber, la plateforme de Cybermalveillance.gouv.fr, qui vous oriente vers les démarches et le dépôt de plainte. Enfin, vérifiez votre DMARC pour fermer la porte à l'usurpation directe.

## Où en est votre domaine ?

En 2 minutes, [CyberGuard vérifie si votre domaine est protégé contre l'usurpation directe](/verifier-dmarc-spf-dkim) : présence de SPF et DKIM, et niveau de votre politique DMARC.
    `,
  },
  {
    slug: "nis2-pme-ce-qui-change",
    title: "NIS2 et PME : qui est concerné, ce qui va changer, et où en est la France",
    excerpt:
      "La directive NIS2 n'est pas encore transposée en France, mais elle concernera des milliers d'entreprises, et leurs fournisseurs. Le point pour une PME.",
    date: "2026-10-14",
    readingTime: "8 min",
    author: "Équipe Cyber-Guard",
    category: "Conformité",
    content: `
La directive européenne NIS2 renforce les obligations de cybersécurité de milliers d'entreprises. Elle devait s'appliquer dans toute l'Union au 17 octobre 2024, mais la France ne l'a toujours pas transposée. Voici ce qu'il faut savoir pour une PME, que vous soyez directement concerné ou fournisseur d'une entreprise qui l'est.

## Où en est la loi française

Au 14 octobre 2026, NIS2 n'est pas encore applicable en France. Le projet de loi « relatif à la résilience des infrastructures critiques et au renforcement de la cybersécurité », qui la transpose, a été adopté par le Sénat en mars 2025, puis par une commission spéciale de l'Assemblée nationale en septembre 2025. Son examen en séance, prévu le 7 octobre 2026, a été reporté la veille, sans nouvelle date. En parallèle, la Commission européenne a saisi la Cour de justice de l'Union européenne en juillet 2026 pour ce retard.

Une fois la loi votée, il faudra encore des décrets d'application pour fixer les délais et les modalités. L'ANSSI a annoncé une mise en œuvre progressive. En attendant, elle met déjà à disposition un simulateur d'éligibilité et un référentiel de mesures de sécurité.

## Votre entreprise est-elle concernée ?

Deux critères se cumulent : votre secteur et votre taille.

Le secteur d'abord. NIS2 couvre 18 secteurs, dont l'énergie, les transports, la santé, l'eau, les infrastructures et services numériques, la gestion des services informatiques pour d'autres entreprises, l'administration publique, mais aussi les services postaux, la gestion des déchets, la chimie, l'agroalimentaire, la recherche et une partie de l'industrie (dispositifs médicaux, électronique, machines, véhicules).

La taille ensuite. Sont visées les entreprises moyennes et grandes de ces secteurs :

- Entité importante : à partir de 50 salariés, ou plus de 10 millions d'euros à la fois de chiffre d'affaires et de bilan.
- Entité essentielle : en général les grandes entreprises des secteurs les plus critiques, à partir de 250 salariés, ou plus de 50 millions d'euros de chiffre d'affaires et 43 millions de bilan.

Les plus petites entreprises sont en principe exclues, sauf exceptions (certains fournisseurs de services DNS ou de confiance, ou entités désignées par l'État). Le simulateur de l'ANSSI, sur MesServicesCyber, permet de vérifier votre cas.

## Ce que NIS2 va demander

Les entités concernées devront s'enregistrer auprès de l'ANSSI, puis :

- Mettre en place des mesures de gestion des risques : analyse de risques, gestion des incidents, continuité d'activité, sécurité des systèmes et des réseaux, contrôle des accès, chiffrement, authentification multifacteur, formation du personnel.
- Maîtriser la sécurité de leurs fournisseurs et prestataires.
- Déclarer les incidents importants : une alerte précoce sous 24 heures, une notification sous 72 heures, un rapport final sous un mois.
- Impliquer la direction : les dirigeants approuvent les mesures, suivent une formation et peuvent voir leur responsabilité engagée.

Les sanctions prévues par la directive vont jusqu'à 10 millions d'euros ou 2 % du chiffre d'affaires mondial pour les entités essentielles, et 7 millions ou 1,4 % pour les entités importantes. Les montants applicables en France seront fixés par la loi.

## Petite entreprise hors périmètre : pourquoi vous serez quand même concerné

C'est le point que beaucoup de PME découvrent tard. Les entreprises soumises à NIS2 doivent s'assurer de la sécurité de leur chaîne d'approvisionnement. Concrètement, si vous êtes prestataire, sous-traitant ou fournisseur informatique d'une entreprise concernée, attendez-vous à recevoir des questionnaires de sécurité et des clauses contractuelles nouvelles. Être capable d'y répondre deviendra un argument commercial.

## Par où commencer, sans attendre la loi

1. Vérifiez votre éligibilité avec le simulateur de l'ANSSI.
2. Faites un premier état des lieux gratuit avec MonAideCyber, le dispositif de l'ANSSI destiné aux PME : un aidant cyber vous accompagne en environ une heure et demie.
3. Corrigez les bases techniques visibles depuis internet : chiffrement HTTPS, configuration du serveur, protection des emails contre l'usurpation. Ce sont les premières choses qu'un client ou un auditeur regardera.

CyberGuard ne certifie pas la conformité NIS2. Il vérifie en revanche en 2 minutes ces mesures techniques de base, [du certificat SSL](/verifier-certificat-ssl) [aux en-têtes de sécurité](/tester-en-tetes-http-securite) et [à la protection des emails](/verifier-dmarc-spf-dkim), et vous explique comment corriger chaque point.
    `,
  },
];

export default blogArticles;
